import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface Breadcrumb {
  label: string;
  path?: string;
}

interface PageBreadcrumbProps {
  breadcrumbs: Breadcrumb[];
}

const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({ breadcrumbs }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '24px',
        fontSize: '12px',
        color: 'var(--text-secondary)',
      }}
    >
      {/* Home icon */}
      <Link
        to="/"
        style={{
          display: 'flex',
          alignItems: 'center',
          color: 'var(--text-secondary)',
          opacity: 0.7,
          transition: 'all 150ms ease',
          textDecoration: 'none',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLElement).style.opacity = '1';
          (e.currentTarget as HTMLElement).style.color = 'var(--signal)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLElement).style.opacity = '0.7';
          (e.currentTarget as HTMLElement).style.color = 'var(--text-secondary)';
        }}
      >
        <HomeIcon style={{ width: 14, height: 14 }} />
      </Link>

      {/* Breadcrumb items */}
      {breadcrumbs.map((crumb, idx) => (
        <React.Fragment key={idx}>
          <ChevronRightIcon style={{ width: 12, height: 12, opacity: 0.4 }} />
          {crumb.path ? (
            <Link
              to={crumb.path}
              style={{
                color: 'var(--text-secondary)',
                opacity: 0.7,
                transition: 'all 150ms ease',
                textDecoration: 'none',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.opacity = '1';
                (e.currentTarget as HTMLElement).style.color = 'var(--signal)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.opacity = '0.7';
                (e.currentTarget as HTMLElement).style.color = 'var(--text-secondary)';
              }}
            >
              {crumb.label}
            </Link>
          ) : (
            <span style={{ color: 'var(--text-primary)', fontWeight: 500 }}>
              {crumb.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PageBreadcrumb;
